module.exports = __webpack_public_path__ + "static/media/logo-leroymerlin.be810e55.png";